// @ts-strict-ignore
import React from 'react';
import { Card } from '@usealloy/component-library';

import ServicesList from '~/entities/evaluations/service/ServicesList';
import { ServicesListNew } from '~/entities/evaluations/service/ServicesListNew';

import { useEventTypeEvaluationsContext } from '../context';
import { useFetchedUserContext } from '~/helpers/hooks';

const DataSources: React.FC = () => {
  const { feature_flags: featureFlags = {} } = useFetchedUserContext();
  const { evaluation, updateSelectedServiceResponse } = useEventTypeEvaluationsContext();

  const showOldDataSource = (!featureFlags?.['show-old-data-sources-eval-detail'] && !featureFlags?.['show-new-data-sources-eval-detail'])
    || featureFlags?.['show-old-data-sources-eval-detail'];
  const showNewDataSource = (!featureFlags?.['show-old-data-sources-eval-detail'] && featureFlags?.['show-new-data-sources-eval-detail'])
    || (featureFlags?.['show-old-data-sources-eval-detail'] && featureFlags?.['show-new-data-sources-eval-detail']);

  return (
    <>
      {showOldDataSource && (
        <Card
          header="Data Sources"
          collapsible
        >
          <ServicesList
            evaluation={evaluation}
            updateSelectedServiceResponse={updateSelectedServiceResponse}
          />
        </Card>
      )}
      {showNewDataSource && (
        <Card
          header="Data Sources"
          collapsible
        >
          <ServicesListNew
            evaluationToken={evaluation.evaluation_token}
            // @ts-ignore
            finalResponse={evaluation?.final_response}
          />
        </Card>
      )}
    </>
  );
};

export default DataSources;
